<template>
    <el-dialog title="添加抖音达人" :visible.sync="talentVisible" width="30%" center :before-close="handleClose">
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="抖音号" label-width="120px" prop="name">
                <el-input size="small" v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="抖音号昵称" label-width="120px" prop="region">
                <el-input size="small" v-model="form.region" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="Cancel()">取 消</el-button>
            <el-button size="mini" type="danger" @click="Submit()">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props:{
        talentVisible:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            form: {
                name: '',
                region: ''
            },
            rules:{
                name: [
                    { required: true, message: '请输入抖音号', trigger: 'blur' },
                ],
                region: [
                    { required: true, message: '请输入抖音号昵称', trigger: 'blur' },
                ],
            }
        }
    },
    watch:{
        talentVisible(val){
            if(val){
                this.$nextTick(()=>{
                    this.$refs['form'].resetFields();
                })
            }
        }
    },
    mounted(){

    },
    methods:{
        handleClose(){
            this.$emit('close', 'close')
        },
        Cancel(){
            this.$emit('close', 'close')
        },
        Submit(){
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    // handle axios
                    this.$emit('success', 'success')
                }else{
                    // handle error
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
    /deep/.el-dialog__header{
        border-bottom: solid 1px #E6E7EB;
    }
</style>